export default __webpack_public_path__ + "static/media/alreadyRegister.fec52c33.svg";